import samtykke_nb from "../nb/samtykke";

const samtykke: typeof samtykke_nb = {
  knapper: {
    abort: {
      label: "Avbryt",
    },
    samtykke: {
      label: "Send kopi til fornærma verksemd",
    },
    close: {
      label: "Lukk",
    },
    send_inn: {
      try_again: "Prøv igjen",
      label: "Send inn",
    },
  },
  input: {
    samtykkeSvarType: {
      label: "Ønsker du å sende ein kopi av din melding til fornærma verksemd?",
      type: {
        JA: "Ja",
        NEI: "Nei",
      },
    },
  },
  modal: {
    feiletInfo: "Noko gjekk galt.",
    senderInn: "Lagrar svar",
    label: "Send svar",
    suksess: "Svar lagra",
  },
};

export default samtykke;
